import { render, staticRenderFns } from "./ProductReviewListItem.vue?vue&type=template&id=7280f204&scoped=true"
import script from "./ProductReviewListItem.vue?vue&type=script&lang=js"
export * from "./ProductReviewListItem.vue?vue&type=script&lang=js"
import style0 from "./ProductReviewListItem.vue?vue&type=style&index=0&id=7280f204&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7280f204",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
